import React from "react";

/**
 * Splits a string by ** and wraps the part(s) inside ** with a span using the provided className.
 * Example: highlightBetweenStars("This is **important** text", "highlight")
 * Output: ["This is ", <span className="highlight">important</span>, " text"]
 */
export function HighLightText(
  text: string,
  highlightClass: string
): (string | React.ReactNode)[] {
  const parts = text?.split(/(\*\*[^*]+\*\*)/g);
  return parts?.map((part, idx) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) {
      const content = part.slice(2, -2);
      return (
        <span className={highlightClass} key={idx}>
          {content}
        </span>
      );
    }
    return part;
  });
}